import { render, staticRenderFns } from "./updateProductAttr.vue?vue&type=template&id=ba244fc8&scoped=true&"
import script from "./updateProductAttr.vue?vue&type=script&lang=js&"
export * from "./updateProductAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba244fc8",
  null
  
)

export default component.exports